import { useVehicleStore } from '@/modules/vehicles/store/useVehicleStore';

/**
 * Returns true if any loaded vehicle is omni-directional OR the debug force-omni override is active.
 * Subscribes to both the vehicle store (runtime state) and the design store (debug preference).
 */
export const useHasOmniVehicles = (): boolean => {
  const hasOmni = useVehicleStore((state) => state.vehicleDetailsState.some((v) => v.omni));
  return hasOmni;
};
